import { render, staticRenderFns } from "./expansion-panel.vue?vue&type=template&id=d677bc8c&scoped=true"
import script from "./expansion-panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./expansion-panel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./expansion-panel.vue?vue&type=style&index=0&id=d677bc8c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d677bc8c",
  null
  
)

export default component.exports